// Team roster for the landing page About section.
//
//  - Headshots: drop square images (~256px) into public/team/ and set the
//    photo field, e.g. photo: '/team/isaiah.jpg'. Entries with photo: null
//    render a warm initials avatar instead, while anonymousGroup entries use
//    a people icon and are excluded from person-level structured data.
//  - Ordering here is display order. `bio` is optional; omit or null to show
//    just the name and role.
export const TEAM = [
  {
    name: 'Ashish Gupta',
    role: 'GTM & Operations',
    bio: null,
    photo: '/team/ashish.jpg',
  },
  {
    name: 'Isaiah Rice',
    role: 'Lead Developer',
    bio: null,
    photo: '/team/isaiah.jpg',
    // Feeds structured data and llms.txt only; the visible card shows `role`.
    founder: true,
  },
  {
    name: 'Rohin Gupta',
    role: 'Data Analytics & Visualization',
    bio: null,
    photo: '/team/rohin.jpg',
    founder: true,
  },
  {
    name: 'Industry advisors',
    role: '401(k) experts · TPAs',
    bio: null,
    photo: null,
    anonymousGroup: true,
  },
]

// Rendered under the team grid; the landing page appends a contact-us link.
export const TEAM_NOTE = 'With support from an independent patent attorney and an actuary.'
